import PropTypes from 'prop-types';
import { GraphCell } from '@amzn/ring-react-components/csr/components/GraphCell';

import './GraphOveragesCell.less';

export default function GraphOveragesCell({ eventCount, overagesThreshold, eventPercentage, overagesEnabled, overagesCap }) {
  const noCapacity = eventCount >= overagesThreshold;
  const noCapacityOverages = overagesEnabled && overagesCap && (eventCount >= overagesThreshold + overagesCap);
  const isServiceInactive = (noCapacity && !overagesEnabled) || noCapacityOverages;
 
  return (
    <GraphCell
      color={isServiceInactive ? 'negative' : 'primary'}
      progress={eventPercentage}
      status="default"
      subtext={
        <>
          {noCapacity && overagesEnabled && (
            <div className="graph-overages-cell__subtext--extra-events"> Extra Events: {eventCount - overagesThreshold} {overagesCap ? ` of ${overagesCap}` : "(no limit set)"} </div>
          )}
          {isServiceInactive && <div className="graph-overages-cell__subtext--critical"> Service inactive </div>}
          Your event count resets at the start of each billing cycle.
        </>
      }
      title={`You’ve used ${noCapacity ? overagesThreshold : eventCount} ${noCapacity && overagesEnabled ? ' out of ' : ' of '}  ${overagesThreshold} ${overagesEnabled ? 'included' : ''} events.`}
    />
  );
}

GraphOveragesCell.propTypes = {
  eventCount: PropTypes.number.isRequired,
  overagesThreshold: PropTypes.number.isRequired,
  eventPercentage: PropTypes.number.isRequired,
  overagesEnabled: PropTypes.bool,
};
